import validator from 'validator'

export const validateDynamicFormData = (
  data,
  requiredFields: string[] = []
) => {
  const errors = {}

  data.map((element) => {
    const [name, value] = element
    if (requiredFields.includes(name) && validator.isEmpty(value)) {
      errors[name] = ['This field cannot be empty']
    }
  })

  return errors
}

export const validateFieldsData = (data) => {
  const errors = {}

  data.map((element) => {
    const [name, obj] = element
    if (obj.required && validator.isEmpty(obj.value)) {
      errors[name] = ['This field is required']
    }
  })

  return errors
}
